import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var line_solid_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M5 11.25h14v1.5H5z" }) });
export {
  line_solid_default as default
};
//# sourceMappingURL=line-solid.js.map
